export const initialState =  {
    aboutme: { },
    friends: { },
    songs: { }
}